module.exports = __webpack_public_path__ + "img/29.aae206ca.jpg";